/**
 * generates tab props in a uniform way
 * @param name tab name
 */
export const tabProps = (name: string) => {
    // Replace characters that don't fit HTML element ID
    const id = name.replaceAll(/\W/g, "-");

    return {
        id: `tab-${id}`,
        "aria-controls": `tabpanel-${id}`,
        value: name,
    };
};
